"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarSkeletonSize = exports.TextSkeletonSize = exports.SkeletonVariant = void 0;
var SkeletonVariant;
(function (SkeletonVariant) {
    SkeletonVariant["TEXT"] = "text";
    SkeletonVariant["AVATAR"] = "avatar";
    SkeletonVariant["RECTANGULAR"] = "rectangular";
})(SkeletonVariant = exports.SkeletonVariant || (exports.SkeletonVariant = {}));
var TextSkeletonSize;
(function (TextSkeletonSize) {
    TextSkeletonSize["BODY"] = "body";
    TextSkeletonSize["HEADER"] = "header";
})(TextSkeletonSize = exports.TextSkeletonSize || (exports.TextSkeletonSize = {}));
var AvatarSkeletonSize;
(function (AvatarSkeletonSize) {
    AvatarSkeletonSize["XS"] = "xs";
    AvatarSkeletonSize["SM"] = "sm";
    AvatarSkeletonSize["MD"] = "md";
    AvatarSkeletonSize["LG"] = "lg";
    AvatarSkeletonSize["XL"] = "l";
    AvatarSkeletonSize["TWOXL"] = "2xl";
})(AvatarSkeletonSize = exports.AvatarSkeletonSize || (exports.AvatarSkeletonSize = {}));
